export class CustomerDetailsRequest {
    salesOrg?: string;
    customerNumber: string;
}

export default CustomerDetailsRequest;